import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessService, StubAccessService, WhiteListedPages } from '../access';

@Injectable({ providedIn: 'root' })
export class AccessFeatureGuard {
  constructor(
    @Inject(StubAccessService) private access: AccessService,
    private router: Router,
  ) {}

  /**
   * Match sub paths of a white listed page
   * e.g. if we are whitelisting "/task-manager/reporting"
   * and the URL is "/task-manager/reporting/accounts/AG-123/projects/TK-123"
   */
  private isWhiteListedPage(url: string): boolean {
    for (const whiteListedPage of WhiteListedPages) {
      if (url.includes(whiteListedPage)) {
        return true;
      }
    }
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const feature = route.data.feature;
    return this.access.hasAccessToFeature(feature).pipe(
      map((hasAccess) => {
        if (hasAccess || this.isWhiteListedPage(state.url)) {
          return true;
        }
        return this.router.createUrlTree(['/restricted/', feature], { queryParams: { page: state.url } });
      }),
    );
  }
}
